import { applyPlaceholderValues } from '@frontend/html-template-editor';
import { NotificationContentClient } from '@frontend/notification/api';
import { useEffect, useState } from 'react';

import { ContentPreviewProps } from './content-preview.component';

export type PreviewViewport = 'desktop' | 'mobile';

export const useContentPreview = (props: ContentPreviewProps) => {
    const [body, setBody] = useState<string | null>(props.draft ? applyPlaceholderValues(props.draft.body, props.placeholderValues) : null);
    const [subject, setSubject] = useState<string>(
        props.draft ? applyPlaceholderValues(props.draft.subject, props.placeholderValues) : (props.content.subject ?? '')
    );
    const [isLoading, setIsLoading] = useState<boolean>(!props.draft);
    const [hasPreviewError, setHasPreviewError] = useState<boolean>(false);
    const [viewport, setViewport] = useState<PreviewViewport>('desktop');

    useEffect(() => {
        if (props.draft) {
            setSubject(applyPlaceholderValues(props.draft.subject, props.placeholderValues));
            setBody(applyPlaceholderValues(props.draft.body, props.placeholderValues));
            setIsLoading(false);
            setHasPreviewError(false);
            return;
        }

        let isMounted = true;
        setIsLoading(true);
        setHasPreviewError(false);
        NotificationContentClient.previewNotificationContent(props.content.account_id, props.content.template_id, props.content.id)
            .then((res) => {
                if (!isMounted) return;
                setSubject(res.subject ?? props.content.subject ?? '');
                setBody(res.body ?? '');
            })
            .catch(() => {
                if (!isMounted) return;
                setHasPreviewError(true);
                setSubject(props.content.subject ?? '');
                setBody(props.content.body ?? '');
            })
            .finally(() => {
                if (isMounted) setIsLoading(false);
            });

        return () => {
            isMounted = false;
        };
    }, [props.content, props.draft, props.placeholderValues]);

    return {
        body,
        subject,
        isLoading,
        hasPreviewError,
        isLocalDraftPreview: Boolean(props.draft),
        viewport,
        setViewport
    };
};
